import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import "../../Style/__button.scss";
import "../ClientsCRUD/ClientsModal.scss";
import "./BanksModal.scss";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import { AddElementsButton } from "../../Components/AddElementsButton";
import Autocomplete from "@mui/material/Autocomplete";

function InsertBanks(props) {
  const headers = authHeader();
  const isEditMode = props.mode === "edit";

  const [AccName, setAccName] = useState("");
  const [IdNumber, setIdNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [adress, setAdress] = useState("");
  const [cityID, setCityID] = useState("");
  const [bankID, setBankID] = useState();
  const [bankAccount, setBankAccount] = useState("");
  const [accEmail, setAccEmail] = useState("");
  const [comment, setComment] = useState("");
  const [phone, setPhone] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [inputBankSearch, setInputBankSearch] = useState("");

  const [stateid, setStateID] = useState("");
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);

  const [city, setCity] = useState([]);
  const [filteredCity, setFilteredCity] = useState([]);

  const [bank, setBank] = useState([]);
  const [filteredBank, setFilteredBank] = useState([]);

  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");
  const [bankeError, setBankError] = useState("");

  const initialSnapshotRef = useRef(null);
  const [showConfirmClose, setShowConfirmClose] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [bankName, setBankName] = useState("");

  const resetForm = () => {
    setAccName("");
    setIdNumber("");
    setVatNumber("");
    setAdress("");
    setCityID("");
    setStateID("");
    setBankID();
    setBankAccount("");
    setAccEmail("");
    setComment("");
    setPhone("");
    setIsActive(true);
    setStateName("");
    setCityName("");
    setBankName("");
    setInputBankSearch("");
    setStateError("");
    setCityError("");
    setBankError("");
    setIsSubmitting(false);
    initialSnapshotRef.current = null;
    setShowConfirmClose(false);
  };

  const setFormFromBank = (bankData) => {
    setAccName(bankData?.AccountName ?? "");
    setIdNumber(bankData?.IdentificationNumber ?? "");
    setVatNumber(bankData?.VATNumber ?? "");
    setAdress(bankData?.Adress ?? "");
    setCityID(bankData?.CityID ?? "");
    setStateID(bankData?.StateID ?? "");
    setBankID(bankData?.BankID ?? "");
    setBankAccount(bankData?.BankAccount ?? "");
    setAccEmail(bankData?.Email ?? "");
    setComment(bankData?.Comment ?? "");
    setPhone(bankData?.PhoneNumbers ?? "");
    setIsActive(
      typeof bankData?.IsActive === "boolean" ? bankData.IsActive : true,
    );
    setStateName(bankData?.StateName ?? "");
    setCityName(bankData?.CityName ?? "");
    setBankName(bankData?.AccountName ?? bankData?.BankName ?? "");
    setInputBankSearch("");
    setStateError("");
    setCityError("");
    setBankError("");
    setIsSubmitting(false);
    initialSnapshotRef.current = {
      IdNumber: bankData?.IdentificationNumber ?? "",
      vatNumber: bankData?.VATNumber ?? "",
      adress: bankData?.Adress ?? "",
      stateid: bankData?.StateID ?? "",
      cityID: bankData?.CityID ?? "",
      bankID: bankData?.BankID ?? "",
      bankAccount: bankData?.BankAccount ?? "",
      accEmail: bankData?.Email ?? "",
      comment: bankData?.Comment ?? "",
      phone: bankData?.PhoneNumbers ?? "",
      bankName: bankData?.AccountName ?? bankData?.BankName ?? "",
      isActive:
        typeof bankData?.IsActive === "boolean" ? bankData.IsActive : true,
    };
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "states", { headers })
      .then((response) => {
        setStates(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const fetchCityByState = async (selectedStateID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Cities/getcitybystate",
        { headers, params: { stateid: selectedStateID } },
      );
      setCity(response.data);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "LicencedBanks", { headers })
      .then((response) => {
        setBank(response.data);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!props.show) {
      return;
    }

    if (isEditMode) {
      if (!props.initialData) {
        return;
      }

      setFormFromBank(props.initialData);
      if (props.initialData.StateID) {
        fetchCityByState(props.initialData.StateID);
      }
      return;
    }

    resetForm();
  }, [props.show, props.initialData, isEditMode]);

  useEffect(() => {
    setFilteredStates(
      states.filter((data) =>
        data.StateName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, states]);

  useEffect(() => {
    setFilteredCity(
      city.filter((data) =>
        data.CityName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, city]);

  useEffect(() => {
    setFilteredBank(
      bank.filter((data) =>
        data.BankName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, bank]);

  const handleInputChange = (newValue) => {
    const inputValue = newValue.replace(/\W/g, "");
    setSearchTerm(inputValue);
  };

  const handleFilterState = (selectedOption) => {
    if (selectedOption && selectedOption.StateID) {
      setStateID(selectedOption.StateID);
      setCityID("");
      setCityName("");
      setCity([]);
      fetchCityByState(selectedOption.StateID);
      setStateName(selectedOption.label);
      setStateError("");
      setCityError("");
    } else {
      setStateID("");
      setStateName("");
      setCityID("");
      setCityName("");
      setCity([]);
    }
  };

  const handleFilterCity = (selectedOption) => {
    if (selectedOption && selectedOption.CityID) {
      setCityID(selectedOption.CityID);
      setCityName(selectedOption.label);
      setCityError("");
    } else {
      setCityID("");
      setCityName("");
    }
  };

  const handleFilterBank = (selectedOption) => {
    if (selectedOption && selectedOption.BankID) {
      setBankID(selectedOption.BankID);
      setBankName(selectedOption.label);
      setBankError("");
    } else {
      setBankID("");
      setBankName("");
    }
  };

  const isDirty = useMemo(() => {
    if (!isEditMode) {
      return (
        IdNumber !== "" ||
        vatNumber !== "" ||
        adress.trim() !== "" ||
        stateid !== "" ||
        cityID !== "" ||
        (bankID != null && bankID !== "") ||
        bankAccount !== "" ||
        accEmail !== "" ||
        comment !== "" ||
        phone !== "" ||
        bankName !== ""
      );
    }

    const snap = initialSnapshotRef.current;
    if (!snap) return false;

    return (
      IdNumber !== snap.IdNumber ||
      vatNumber !== snap.vatNumber ||
      adress !== snap.adress ||
      stateid !== snap.stateid ||
      cityID !== snap.cityID ||
      bankID !== snap.bankID ||
      bankAccount !== snap.bankAccount ||
      accEmail !== snap.accEmail ||
      comment !== snap.comment ||
      phone !== snap.phone ||
      bankName !== snap.bankName ||
      isActive !== snap.isActive
    );
  }, [
    isEditMode,
    IdNumber,
    vatNumber,
    adress,
    stateid,
    cityID,
    bankID,
    bankAccount,
    accEmail,
    comment,
    phone,
    bankName,
    isActive,
  ]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    if (stateid == null || stateid === "") {
      setStateError("Plotësoni shtetin");
      return;
    } else {
      setStateError("");
    }

    if (cityID == null || cityID === "") {
      setCityError("Plotësoni qytetin");
      return;
    } else {
      setCityError("");
    }

    if (bankID == null || bankID === "") {
      setBankError(
        "Fillimisht zgjedheni bankën e licencuar dhe më pas mund ta modifikoni emërtimin",
      );
      return;
    } else {
      setBankError("");
    }

    setIsSubmitting(true);

    const stateDate = {
      AccountName: bankName,
      LedgerID: 102,
      IdentificationNumber: IdNumber,
      VATNumber: vatNumber,
      Adress: adress,
      CityID: cityID,
      StateID: stateid,
      BankID: bankID,
      BankAccount: bankAccount,
      Email: accEmail,
      Comment: comment,
      PhoneNumbers: phone,
      IsActive: isActive,
    };

    const submitRequest = isEditMode
      ? axios.put(
          ApiLink.API_URL + "Accounts/updateAccount",
          {
            ...stateDate,
            AccountID: props.initialData?.AccountID,
          },
          { headers },
        )
      : axios.post(ApiLink.API_URL + "Accounts/insertAccount", stateDate, { headers });

    submitRequest
      .then(() => {
        handleSuccess(
          isEditMode
            ? "Banka u përditësua me sukses"
            : "Banka u shtua me sukses",
        );
        resetForm();
        props.onHide();
        props.refreshData();
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert(
            "Ka ndodhur një gabim i panjohur gjatë përpunimit të kërkesës.",
          );
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const doClose = () => {
    props.onHide();
    resetForm();
  };

  const handleClose = () => {
    if (isSubmitting) {
      return;
    }

    if (isDirty) {
      setShowConfirmClose(true);
      return;
    }

    doClose();
  };

  return (
    <>
      <Modal
        {...props}
        onHide={handleClose}
        backdrop={isSubmitting ? "static" : true}
        keyboard={!isSubmitting}
        size="lg"
        dialogClassName="clients-modal-dialog banks-modal-dialog"
        contentClassName="clients-modal-content banks-modal-content"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="clients-modal-header">
          <div className="clients-modal-header-content">
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="clients-modal-title"
            >
              {isEditMode
                ? "Përditëso të dhënat e bankës"
                : "Krijo një bankë të re"}
            </Modal.Title>
            <p className="clients-modal-subtitle">
              {isEditMode
                ? "Ndrysho të dhënat e bankës dhe ruaji për përditësim në sistem."
                : "Plotësoni të dhënat e bankës dhe ruani për ta shtuar në sistem."}
            </p>
            <div className="clients-modal-meta">
              <span className="clients-meta-pill">
                Fushat me * janë obligative
              </span>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="clients-modal-body">
          <form onSubmit={handleSubmit} className="clients-form">
            <section className="clients-section">
              <h6 className="clients-section-title">Informata Kryesore</h6>
              <div className="clients-grid clients-grid-2">
                <div className="clients-field clients-field-full">
                  <Autocomplete
                    id="BankID"
                    freeSolo
                    options={filteredBank.map((data) => ({
                      label: data.BankName,
                      value: data.BankID,
                      BankID: data.BankID,
                    }))}
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      return option.label || "";
                    }}
                    value={
                      inputBankSearch !== ""
                        ? inputBankSearch
                        : bankID && bankName
                          ? { label: bankName, value: bankID }
                          : null
                    }
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        setBankID("");
                        setBankName(newValue);
                        setInputBankSearch(newValue);
                        handleFilterBank(null);
                      } else if (newValue) {
                        setBankID(newValue.value);
                        setBankName(newValue.label);
                        setInputBankSearch("");
                        handleFilterBank(newValue);
                      } else {
                        setBankID("");
                        setBankName("");
                        setInputBankSearch("");
                        handleFilterBank(null);
                      }
                    }}
                    onInputChange={(event, newInputValue) => {
                      setInputBankSearch(newInputValue);
                      setBankName(newInputValue);
                      handleInputChange(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        label="Zgjedheni Bankën *"
                        placeholder="Zgjedheni Bankën"
                        size="small"
                      />
                    )}
                    noOptionsText="Nuk u gjet asnjë përputhje"
                  />
                  <span className="clients-error">
                    {bankeError && `${bankeError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <TextField
                    fullWidth
                    required
                    id="IdentificationNumber"
                    label="Numri i Llogarisë *"
                    variant="outlined"
                    type="text"
                    name="IdentificationNumber"
                    value={IdNumber}
                    onChange={(event) => setIdNumber(event.target.value)}
                    autoComplete="off"
                    size="small"
                  />
                </div>

                <div className="clients-field">
                  <TextField
                    fullWidth
                    required
                    id="Adress"
                    label="Adresa *"
                    variant="outlined"
                    type="text"
                    name="Adress"
                    value={adress}
                    onChange={(event) => setAdress(event.target.value)}
                    autoComplete="off"
                    size="small"
                  />
                </div>

                <div className="clients-field">
                  <label className="clients-select-label">
                    Përzgjedh Shtetin *
                  </label>
                  <Select
                    inputId="StateID"
                    classNamePrefix="clients-select"
                    value={
                      stateid
                        ? { label: stateName, value: stateid, StateID: stateid }
                        : null
                    }
                    options={filteredStates.map((data) => ({
                      label: data.StateName,
                      value: data.StateID,
                      StateID: data.StateID,
                    }))}
                    onInputChange={handleInputChange}
                    onChange={handleFilterState}
                    isClearable
                    placeholder="Select"
                    noOptionsMessage={() => "Nuk u gjet asnjë përputhje"}
                    components={{ IndicatorSeparator: () => null }}
                  />
                  <span className="clients-error">
                    {stateError && `${stateError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <label className="clients-select-label">
                    Përzgjedh Qytetin *
                  </label>
                  <Select
                    inputId="CityID"
                    classNamePrefix="clients-select"
                    value={
                      cityID
                        ? { label: cityName, value: cityID, CityID: cityID }
                        : null
                    }
                    options={filteredCity.map((data) => ({
                      label: data.CityName,
                      value: data.CityID,
                      CityID: data.CityID,
                    }))}
                    onInputChange={handleInputChange}
                    onChange={handleFilterCity}
                    isClearable
                    placeholder="Select"
                    noOptionsMessage={() => "Nuk u gjet asnjë përputhje"}
                    components={{ IndicatorSeparator: () => null }}
                  />
                  <span className="clients-error">
                    {cityError && `${cityError}`}
                  </span>
                </div>
              </div>
            </section>

            <section className="clients-section">
              <h6 className="clients-section-title">Kontakt dhe Koment</h6>
              <div className="clients-grid clients-grid-2">
                <div className="clients-field">
                  <TextField
                    fullWidth
                    id="Email"
                    label="Email"
                    variant="outlined"
                    type="text"
                    name="Email"
                    value={accEmail}
                    onChange={(event) => setAccEmail(event.target.value)}
                    autoComplete="off"
                    size="small"
                  />
                </div>

                <div className="clients-field">
                  <TextField
                    fullWidth
                    id="PhoneNumber"
                    label="Numri i Telefonit"
                    variant="outlined"
                    type="text"
                    name="PhoneNumber"
                    value={phone}
                    onChange={(event) => setPhone(event.target.value)}
                    autoComplete="off"
                    size="small"
                  />
                </div>

                <div className="clients-field clients-field-full">
                  <textarea
                    rows={2}
                    className="clients-notes"
                    id="Comment"
                    placeholder="Komenti"
                    name="Comment"
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                    autoComplete="off"
                  />
                </div>

                {isEditMode && (
                  <div className="clients-field clients-field-full">
                    <label className="clients-active-toggle">
                      <input
                        type="checkbox"
                        className="clients-active-checkbox"
                        checked={Boolean(isActive)}
                        onChange={(event) => setIsActive(event.target.checked)}
                        disabled={isSubmitting}
                      />
                      <span className="clients-active-copy">
                        <span className="clients-active-title">Statusi i bankës</span>
                        <span className="clients-active-description">
                          {isActive ? "Banka është aktive në sistem" : "Banka është joaktive në sistem"}
                        </span>
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </section>

            <div className="clients-modal-footer">
              <Button
                type="submit"
                variant="contained"
                className="clients-save-btn"
                disabled={isSubmitting || (isEditMode && !isDirty)}
              >
                {isSubmitting
                  ? "Duke ruajtur..."
                  : isEditMode
                    ? "Përditëso & Mbyll"
                    : "Ruaj & Mbyll"}
              </Button>
              <Button
                variant="outlined"
                className="clients-close-btn"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Mbyll
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Dialog
        open={showConfirmClose}
        onClose={() => setShowConfirmClose(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Konfirmo mbylljen</DialogTitle>
        <DialogContent>
          Keni ndryshime të paruajtura. Nëse mbyllni tani, të dhënat e
          ndryshuara do të humbin. A jeni të sigurt?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirmClose(false)} variant="outlined">
            Kthehu
          </Button>
          <Button onClick={doClose} variant="contained" color="error">
            Po, mbyll pa ruajtur
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default function BanksModal(props) {
  const [internalModalShow, setInternalModalShow] = React.useState(false);
  const isControlled = typeof props.show === "boolean";
  const modalShow = isControlled ? props.show : internalModalShow;

  const openModal = () => {
    if (isControlled) {
      return;
    }

    setInternalModalShow(true);
  };

  const closeModal = () => {
    if (isControlled) {
      if (props.onHide) {
        props.onHide();
      }
      return;
    }

    setInternalModalShow(false);
  };

  const handleRefreshData = () => {
    if (props.fetchData) {
      props.fetchData();
    }
  };

  return (
    <>
      {!isControlled && (
        <AddElementsButton
          text="Krijo Bankë"
          onClick={openModal}
          icon="bi bi-plus-circle"
          className="button-68"
        />
      )}

      <InsertBanks
        show={modalShow}
        onHide={closeModal}
        refreshData={handleRefreshData}
        mode={props.mode}
        initialData={props.initialData}
      />
    </>
  );
}
